// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const RemoveIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Remove",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.57 29.48c.32.32.75.51 1.24.51s.92-.2 1.24-.51L16.03 18.5l11 10.98c.32.32.75.51 1.24.51A1.752 1.752 0 0 0 29.51 27l-11-10.98 10.98-11c.28-.31.46-.72.46-1.17a1.741 1.741 0 0 0-2.92-1.28s-11 10.98-11 10.98l-11-10.98a1.741 1.741 0 1 0-2.47 2.45s10.98 11 10.98 11l-10.97 11c-.31.31-.51.75-.51 1.23s.19.92.51 1.23"
    })
  });
};